export function distance(point1, point2) {
    let a = point1.leaflet_params.endPoint[0] - point2.leaflet_params.endPoint[0]
    let b = point1.leaflet_params.endPoint[1] - point2.leaflet_params.endPoint[1]
    return Math.sqrt(a * a + b * b)
}

export function imgNameToUrl(imgName) {
    return 'https://img.lkval.com/userupload/' + imgName
}


export function formatISOTime(isoString) {
    const date = new Date(isoString);
    const Y = date.getFullYear();
    const M = String(date.getMonth() + 1).padStart(2, '0');
    const D = String(date.getDate()).padStart(2, '0');
    const h = String(date.getHours()).padStart(2, '0');
    const m = String(date.getMinutes()).padStart(2, '0');
    const s = String(date.getSeconds()).padStart(2, '0');
    return `${Y}-${M}-${D} ${h}:${m}:${s}`;
}